const COOKIE_NAME = 'userLanguagePreference'
const COOKIE_MAX_AGE_DAYS = 365
const HUBBELL_COM_DOMAIN = '.hubbell.com'
const HUBBELL_CA_DOMAIN = '.hubbell.ca'

/**
 * Determines the appropriate cookie domain based on the current hostname.
 * Sets the cookie on .hubbell.com or .hubbell.ca so it is shared across subdomains.
 * Falls back to current hostname for local/dev environments.
 */
const getCookieDomain = () => {
  const hostname = window.location.hostname
  if (hostname.endsWith(HUBBELL_COM_DOMAIN)) {
    return HUBBELL_COM_DOMAIN
  }
  if (hostname.endsWith(HUBBELL_CA_DOMAIN)) {
    return HUBBELL_CA_DOMAIN
  }
  // Local / dev — don't set a domain so the cookie scopes to the current host
  return ''
}

/**
 * Reads the userLanguagePreference cookie value.
 * @returns {string|null} The stored language code, or null if not set.
 */
export const getLanguageCookie = () => {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_NAME}=`))
  return match ? decodeURIComponent(match.split('=')[1]) : null
}

/**
 * Writes the userLanguagePreference cookie on the appropriate domain.
 * @param {string} locale - The locale key to persist (e.g. 'en', 'fr', 'es').
 */
export const setLanguageCookie = (locale) => {
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60 // seconds
  const domain = getCookieDomain()
  const domainPart = domain ? `; domain=${domain}` : ''

  document.cookie = [
    `${COOKIE_NAME}=${encodeURIComponent(locale)}`,
    'path=/',
    `max-age=${maxAge}`,
    'SameSite=Lax',
    'Secure',
    domainPart
  ]
    .filter(Boolean)
    .join('; ')
}
